<ngx-smart-modal #manualModal identifier="manualModal" [customClass]="Utility.mobile ? 'full-width' : ''">
	<div class="w-100 p-2 f-initial">
		<h6 class="kp-title-line">فعالسازی سرویس با کارت‌به‌کارت</h6>
		<div>
			لطفا مبلغ <b class="fs-xl">{{amount*10|number}} ریال</b>
			به شماره کارت زیر واریز و 4 رقم آخر کارت خودتان را جهت بررسی ارسال کنید.
			<br />
			<div class="w-100 text-center border my-1 pt-2">
				<span class="fw-bold fs-xl ff-sans-serif" dir="ltr" [copy]="'6104338801454436'"
					message="شماره کارت کپی شد">6104-3388-0145-4436</span>
				<br />
				<span class="fs-lg">شرکت «کاوشگر کیان <b>کارپیشه</b>»</span>
				<br />
				<span class="fs-sm lh-1">برای کپی، شماره کارت را لمس کنید</span>
			</div>
			<form>
				<label>
					<span><span class="fw-bold">4 رقم آخر شماره کارت خودتان</span> که از آن واریز می‌کنید:</span>
					<input [(ngModel)]="manualToken" name="manualToken" required placeholder="مثال: 1234" />
				</label>
				<div class="text-left">
					<button type="button" (click)="pay();manualModal.close()" class="btn btn-primary"
						[class.disabled]="!manualToken" containerClass="tooltip-warning" triggers="focus"
						[tooltip]="!manualToken ? 'اطلاعات را دقیق و کامل وارد کنید':undefined">ارسال</button>
				</div>
			</form>
			<!-- <hr />
			و یا با شماره
			<app-whatsapp-message mobile="2128429921" label="واتس‌اپ" text="سلام، برای کارت به کارت نیاز به راهنمایی دارم.">
			</app-whatsapp-message>
			تماس حاصل فرمایید. -->
		</div>
	</div>
</ngx-smart-modal>